export default __webpack_public_path__ + "static/media/logo-image.9f7cccff.jpg";